import { ArrowHeadRightIcon, Select, SelectOptionType } from '@bp/ui-components';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { lowercaseFirstLetter, naturalStringSort } from '../../../utils/stringHelper';
import { StudentMapping, XlsxImportEntry } from '../types/XlsxImportTypes';
import styles from './_XlsxImportForms.module.scss';

type XlsxStudentMappingFormRowProps = {
  id: number;
  entry: XlsxImportEntry<StudentMapping>;
  profiles: { uuid: string; name: string }[];
  selectedProfile: { uuid: string; name: string } | null;
  onProfileSelect: (profileUuid: string | null) => void;
};

export const XlsxStudentMappingFormRow = ({
  id,
  entry,
  profiles,
  selectedProfile,
  onProfileSelect,
}: XlsxStudentMappingFormRowProps) => {
  const { t } = useTranslation();

  const { firstName, lastName, grade } = entry;

  const profileOptions: SelectOptionType[] = profiles
    .map((p) => ({ value: p.uuid, label: p.name }))
    .sort((a, b) => naturalStringSort(a.label, b.label));

  return (
    <div className={classNames(styles['xlsx-mapping-form-row'], styles.students)}>
      <div className={styles.name}>
        {firstName} {lastName} ({grade})
      </div>
      <div className={styles.icon}>
        <ArrowHeadRightIcon />
      </div>
      <div className={styles.select}>
        <Select
          dense
          options={profileOptions}
          name={`select-profile-${id}`}
          placeholder={lowercaseFirstLetter(t('import.willBeCreated'))}
          onChange={(event) => {
            const selectOption = event as SelectOptionType;
            const uuid = selectOption ? (selectOption.value as string) : null;
            onProfileSelect(uuid);
          }}
          value={selectedProfile ? { value: selectedProfile.uuid, label: selectedProfile.name } : undefined}
          isClearable
          isSearchable
          menuPosition='fixed'
        />
      </div>
    </div>
  );
};
